<template>
  <footer class="footer">
    <div class="footer-container">
      <a href="https://www.linkedin.com/in/seth-foster/" target="_blank" rel="noopener" class="linkedin-link">
        <img src="@/assets/linkedin-logo.png" alt="LinkedIn" class="social-icon" />
      </a>
      <p>&copy; 2026 Seth Foster. All rights reserved.</p>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterBar",
};
</script>

<style scoped>
.footer {
  margin-top: 2rem;
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  background-color: var(--surface-bg);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
  animation: fadeInUp 2s ease-in-out;
  border-radius: 5px;
}

.footer-container {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 1rem;
}

.linkedin-link {
  display: flex;
  align-items: center;
}

.social-icon {
  width: 50px;
  height: auto;
  transition: transform 0.3s ease;
}

.social-icon:hover {
  transform: scale(1.08);
}

.footer p {
  font-size: 1rem;
  font-weight: 400;
  letter-spacing: 0.5px;
}

@media (max-width: 1200px) {
    .footer {    
    border-radius: 0;
  }
}

/* Responsive styles */
@media (max-width: 768px) {
  .footer {
    flex-direction: column;
    align-items: center;
    padding: 1rem;
    box-shadow: none;
    border-radius: 0;
    margin-top: 0;
  }

  .footer-container {
    flex-direction: column;
    align-items: center;
    gap: 1rem;
  }

  .footer p {
    text-align: center;
  }

  .social-icon {
    width: 40px;
  }
}

@media (max-width: 480px) {
  .footer p {
    font-size: 0.8rem;
  }

  .social-icon {
    width: 30px;
  }
}
</style>
